

// 声明一个变量来存储动态加载的Stripe模块
let stripe: any = null;
// import ProServer from "@/services/ProServer";

class StripeUtils {
    static isLoaded = false;

    // 添加一个方法来动态加载PDF.js
    static async loadStripe() {
        if (this.isLoaded) return;
        console.log("loadStripe")
        try {
            // 动态导入PDF.js模块
            const currentStripe = await import('@stripe/stripe-js');
            stripe = currentStripe;

            this.isLoaded = true;
            console.log("stripe.js loaded successfully");
        } catch (error) {
            console.error("Failed to load stripe.js:", error);
            // 弹出提示：网络或者浏览器版本过低
            // const { $i18n } = useNuxtApp()
            // const t = $i18n.global.t
            // throw new Error(t('browser-low-tip'));
        }
    }

    static async openStripeCheckOut(param: any, callback: (paymentIntent: any) => void) {
        await this.loadStripe();
        this.saveRouter()
        if (stripe) {
            // let res = await ProServer.getRequestBuyTranslateTrade(param)
            // if (res.code == '1') {
            //     callback(null)
            //     const { clientSecret, orderNo, stripeSessionId } = res.data
            //     if(stripeSessionId){
            //         const publishableKey = useRuntimeConfig().public.stripePublicKey
            //         const stripeFunc = await stripe.loadStripe(publishableKey);
            //         try {
            //             const paymentIntent= await stripeFunc.redirectToCheckout({ sessionId: stripeSessionId });
            //             console.log('Payment result:', paymentIntent);
            //         } catch (error) {
            //             console.error("Failed to redirect to checkout:", error);
            //         }
            //     }
            // }else {
            //     callback(res.message)
            // }
        }
    }


    static saveRouter() {
        localStorage.removeItem("payRouter")
        localStorage.setItem("payRouter", JSON.stringify({url:useRoute().path, query: useRoute().query}))
    }
}

export default defineNuxtPlugin(nuxtApp =>{
    nuxtApp.$StripeUtils = StripeUtils
})